"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveThunkMap = resolveThunkMap;
exports.resolveValueFromThunkMap = resolveValueFromThunkMap;
exports.resolveValueFromThunk = resolveValueFromThunk;
function resolveThunkMap(map) {
    return Object.fromEntries(Object.entries(map).map(([key, value]) => [key, typeof value === 'function' ? value() : value]));
}
function resolveValueFromThunkMap(map, key, throwIfUndefined = false) {
    const value = resolveValueFromThunk(map[key]);
    if (throwIfUndefined && value === undefined) {
        throw new Error(`Value for key ${String(key)} is undefined`);
    }
    return value;
}
function resolveValueFromThunk(value) {
    return typeof value === 'function' ? value() : value;
}
//# sourceMappingURL=ThunkMap.js.map